/*
 * @Descripttion: 保存开通场景入参构建
 * @Date: 2026-07-02 10:00:00
 */
import type {
  SaveOpenedScenesParams,
  ScenePriceSceneItem
} from '../data-source/types';
import { yuan2fen } from '@/utils/translator';

type SaveSceneSource = Pick<
  ScenePriceSceneItem,
  | 'id'
  | 'enabled'
  | 'platformPriceLower'
  | 'platformPriceUpper'
  | 'industryPriceLower'
  | 'industryPriceUpper'
> & {
  minText?: string;
  maxText?: string;
};

/**
 * 获取场景保存用的价格区间
 */
const getSavePriceRange = (scene: SaveSceneSource): [number, number] => {
  if (scene.minText != null && scene.maxText != null) {
    return [Number(scene.minText), Number(scene.maxText)];
  }
  return [
    scene.industryPriceLower ?? scene.platformPriceLower,
    scene.industryPriceUpper ?? scene.platformPriceUpper
  ];
};

/**
 * 构建 saveOpenedScenes 接口入参
 */
export const buildSaveOpenedScenesParams = (
  industryId: string | number,
  scenes: SaveSceneSource[]
): SaveOpenedScenesParams => ({
  industryId: Number(industryId),
  serviceProjectIds: scenes
    .filter(item => item.enabled)
    .map(item => {
      const [priceLower, priceUpper] = getSavePriceRange(item);
      return {
        serviceProjectId: Number(item.id),
        priceLower: yuan2fen(priceLower),
        priceUpper: yuan2fen(priceUpper)
      };
    })
});
